export default __webpack_public_path__ + "static/media/edit.10b4b165.svg";